<circ-loader [isLoading]="!isReady"></circ-loader>
<div class="row" *ngIf="isReady">
  <kendo-card [width]="'100%'">
    <div class="k-vbox">
      <kendo-card-header>
        <h5 kendoCardTitle>{{ template?.title }}</h5>
      </kendo-card-header>
      <hr kendoCardSeparator [orientation]="'vertical'" />
      <kendo-card-body>
        <p>
          <kendo-icon name="info" themeColor="primary"></kendo-icon>
          {{ template?.payload?.demand }}
        </p>
      </kendo-card-body>
      <hr kendoCardSeparator [orientation]="'vertical'" />
      <kendo-card-actions [layout]="'stretched'">
        <ece-btn-delete [title]="'templates_details_button_delete' | i18n " (click)="deleteTemplate(template)"
          *ngIf="canDelete"> {{'templates_details_button_delete' | i18n}}
        </ece-btn-delete>
        <hr kendoCardSeparator [orientation]="'vertical'" />
        <ece-btn-edit [title]="'templates_details_button_edit' | i18n" (click)="editTemplate(template)">
          {{'templates_details_button_edit' | i18n}}</ece-btn-edit>
      </kendo-card-actions>

    </div>
  </kendo-card>

  <!-- MetaData -->
  <div class="row mt-5">
    <div class="col">
      <div class="mobile-template">
        <kendo-grid [data]="template?.payload?.data" [height]="'auto'">
          <ng-template kendoGridToolbarTemplate>
            <div>
              <div class="d-flex flex-row flex-wrap align-items-center">
                <div class="grid-toolbar-title">{{'circ_details_header_metadata' | i18n}}</div>
                <help-link [target]="helpTargetMetadata"></help-link>
              </div>
              <div class="d-flex flex-row flex-wrap align-items-start">
                <ece-btn-add [title]="'circ_details_button_addMetadata' | i18n" (click)="addMetaData()">
                  {{'circ_details_button_addMetadata' | i18n}}
                </ece-btn-add>
              </div>
            </div>
          </ng-template>

          <kendo-grid-column>
            <ng-template kendoGridCellTemplate let-x>
              <h5>{{'circ_new_label_key' | i18n}}: {{ x.key }} {{'circ_new_label_value_type' | i18n}}: {{ x.valueType }}</h5>
                <div class="d-flex flex-row justify-flex-start mt-4">
                  <ece-btn-edit [title]="'data_edit_button_edit' | i18n" (click)="editData(x, template)"> {{'data_edit_button_edit' | i18n}}
                  </ece-btn-edit>
                  <ece-btn-delete [title]="'data_edit_button_delete' | i18n" (click)="deleteData(x, template)"> {{'data_edit_button_delete' | i18n}}
                  </ece-btn-delete>
                </div>
              </ng-template>

          </kendo-grid-column>
        </kendo-grid>
      </div>
      <div class="desktop-template">
        <kendo-grid [data]="template?.payload?.data" [height]="'auto'">
          <ng-template kendoGridToolbarTemplate>
            <div>
              <div class="d-flex flex-row flex-wrap align-items-center">
                <div class="grid-toolbar-title">{{'circ_details_header_metadata' | i18n}}</div>
                <help-link [target]="helpTargetMetadata"></help-link>
              </div>
              <div class="d-flex flex-row flex-wrap align-items-start">
                <ece-btn-add [title]="'circ_details_button_addMetadata' | i18n" (click)="addMetaData()">
                  {{'circ_details_button_addMetadata' | i18n}}
                </ece-btn-add>
              </div>
            </div>
          </ng-template>

          <kendo-grid-column [title]="'templates_grid_metadata_key' | i18n">
            <ng-template kendoGridCellTemplate let-x>
              <span>{{ x.key }}</span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column [title]="'templates_grid_metadata_value' | i18n">
            <ng-template kendoGridCellTemplate let-x>
              <span>{{ x.valueType }}</span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column>
            <ng-template kendoGridCellTemplate let-x>
              <ece-btn-edit [title]="'data_edit_button_edit' | i18n" (click)="editData(x, template)">
              </ece-btn-edit>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column>
            <ng-template kendoGridCellTemplate let-x>
              <ece-btn-delete [title]="'data_edit_button_delete' | i18n" (click)="deleteData(x, template)">
              </ece-btn-delete>
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
      </div>
    </div>
  </div>

  <div class="row mt-5">
    <div class="col">
      <div class="mobile-template">
        <kendo-grid [data]="steps" [height]="'auto'">
          <!-- Mobile Template -->
          <ng-template kendoGridToolbarTemplate>
            <div>
              <div class="d-flex flex-row flex-wrap align-items-center">
                <div class="grid-toolbar-title">{{'circ_details_header_steps' | i18n}}</div>
                <help-link [target]="helpTargetSteps"></help-link>
              </div>
              <div class="d-flex flex-row flex-wrap align-items-start">
                <ece-btn-add [title]="'circ_details_button_addStep' | i18n" (click)="addStep()">
                  {{'circ_details_button_addStep' | i18n}}
                </ece-btn-add>
              </div>
            </div>
          </ng-template>

          <kendo-grid-column [title]="'grid_title_mobile' | i18n">
            <ng-template kendoGridCellTemplate let-x>
              <h5>
                {{ x.payload.data.title }}
              </h5>
              <div class="d-flex flex-row align-center">
                <div>{{'grid_assignedTo' | i18n}}:</div>
                <div class="d-flex flex-column align-items-start justify-content-center">
                  <div *ngFor="let assignee of (x.tasks.assignedTo || [])">
                    <circ-person-from-login [login]="assignee.login" [showLogin]="false" [showImage]="false"
                      [fontSize]="14">
                    </circ-person-from-login>
                  </div>
                </div>
              </div>
              <div class="nobr">
                <span>{{'templates_grid_duration' | i18n}}:</span>
                <span>{{x.duration}}</span>
              </div>
              <div class="d-flex flex-row justify-flex-start mt-4">
                <ece-btn-edit [title]="'step_details_steps_edit' | i18n" (click)="onEdit(x)">
                  {{'step_details_steps_edit' | i18n}}
                </ece-btn-edit>
                <ece-btn-delete [title]="'step_edit_button_delete' | i18n" (click)="deleteStep(x, template)">
                  {{'step_edit_button_delete' | i18n}}
                </ece-btn-delete>
              </div>
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
      </div>
      <!-- Desktop Template -->
      <div class="desktop-template">
        <kendo-grid [data]="steps" [height]="'auto'">
          <ng-template kendoGridToolbarTemplate>
            <div>
              <div class="d-flex flex-row flex-wrap align-items-center">
                <div class="grid-toolbar-title">{{'circ_details_header_steps' | i18n}}</div>
                <help-link [target]="helpTargetSteps"></help-link>
              </div>
              <div class="d-flex flex-row flex-wrap align-items-start">
                <ece-btn-add [title]="'circ_details_button_addStep' | i18n" (click)="addStep()">
                  {{'circ_details_button_addStep' | i18n}}
                </ece-btn-add>
              </div>
            </div>
          </ng-template>

          <kendo-grid-column [title]="'templates_grid_title' | i18n">
            <ng-template kendoGridCellTemplate let-x>
              <span>{{ x.payload.data.title }}</span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column [title]="'grid_assignedTo' | i18n">
            <ng-template kendoGridCellTemplate let-x>
              <span *ngFor="let assignee of (x.tasks.assignedTo || [])">
                <circ-person-from-login [login]="assignee.login" [showLogin]="false" [showImage]="false">
                </circ-person-from-login>
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column [title]="'templates_grid_duration' | i18n">
            <ng-template kendoGridCellTemplate let-x>
              <span>{{ x.duration }}</span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column>
            <!-- actions -->
            <ng-template kendoGridCellTemplate let-x>
              <ece-btn-edit [title]="'step_details_steps_edit' | i18n" (click)="onEdit(x)"></ece-btn-edit>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column>
            <!-- actions -->
            <ng-template kendoGridCellTemplate let-x>
              <ece-btn-delete [title]="'step_edit_button_delete' | i18n" (click)="deleteStep(x, template)">
              </ece-btn-delete>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-messages [noRecords]="'kendo_noRecords' | i18n">
          </kendo-grid-messages>
        </kendo-grid>
      </div>
    </div>
  </div>
</div>
